import React from 'react';
import { AdviceFooter } from '@trp-individual-investor-adv-disc/adv-shared';
import FPSThemeWrapper from '../FPSThemeWrapper/FPSThemeWrapper';
import BlueBanner from '../BlueBanner/BlueBanner';
import './AppWrapper.scss';
// import { rasADV } from '../shared/Links';

const AppWrapper = ({children, status}) => {
    const hasAccounts = (status && status.clientHasAccounts) || (status && status.coClientHasAccounts);
    const noWrapStyle = { whiteSpace: 'nowrap' };
    const DisclosureContent = () => <div className='footerDisclosuresWrapper'>
        <div className='footerDisclosuresContent'>
            <div>
                Investments in the <span style={noWrapStyle}>T. Rowe Price</span> Retirement Advisory Service&trade; portfolios are subject to the risks associated with
                investing in mutual funds and exchange-traded funds, which may result in loss of principal. <span style={noWrapStyle}>T. Rowe Price</span> does not guarantee
                the results of our investment management, or that the objectives of the funds or the portfolios will be met.
                <br /><br />
                The <span style={noWrapStyle}>T. Rowe Price</span> Retirement Advisory Service&trade; is a nondiscretionary financial planning and retirement income planning service
                and a discretionary managed account program provided by <span style={noWrapStyle}>T. Rowe Price</span> Advisory Services, Inc.,
                a registered investment adviser under the Investment Advisers Act of 1940. Brokerage accounts for the
                Retirement Advisory Service are provided by <span style={noWrapStyle}>T. Rowe Price</span> Investment Services, Inc., member FINRA/SIPC,
                and are carried by Pershing LLC, a BNY Mellon Company, member NYSE/FINRA/SIPC, which acts as a clearing
                broker for <span style={noWrapStyle}>T. Rowe Price</span> Investment Services, Inc. <span style={noWrapStyle}>T. Rowe Price</span> Advisory Services Inc.
                and <span style={noWrapStyle}>T. Rowe Price</span> Investment Services Inc. are affiliated companies.
                <br /><br />
                <strong>ETFs are bought and sold at market prices, not net asset value.</strong> Investors generally incur the cost of the spread
                between the prices at which shares are bought and sold and may incur additional transaction costs.
            </div>
            <div>202307 - 2931001</div>
        </div>
    </div>;

    return (
        <div  id="captureProposal">
            <FPSThemeWrapper>
                <BlueBanner
                    header='Retirement Advisory Service'
                    subheader='Partner with our professionals and we’ll help you be more confident about reaching your financial goals.'
                />
            </FPSThemeWrapper>
                {children}
                <div className='footerVerticalSpacer' />
            <AdviceFooter
                copyright='RAS'
                disclosures={<DisclosureContent />}
            />
            {hasAccounts ? (
                <div style={{ height: '150px', backgroundColor: '#3B3B3B' }} />
            )
            :
            null
        }
        </div>
    )
}

export default AppWrapper;